import { render, staticRenderFns } from "./SingleFarmingProject.vue?vue&type=template&id=1cf4fcde&scoped=true&"
import script from "./SingleFarmingProject.vue?vue&type=script&lang=js&"
export * from "./SingleFarmingProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4fcde",
  null
  
)

export default component.exports